const Main = () => import("@/views/main/main");
const Common = () => import("@/views/common/common");
const CommonUserInfo = () => import("@/views/common/user-info/index");
const CommonWxLogin = () => import("@/views/common/wxlogin");
const Login = () => import("@/views/login/login");
const Person = () => import("@/views/person/person");
const FunctionList = () => import("@/views/function_list/function_list");
const StaffAdmin = () => import("@/views/staff_admin/staff_admin");
const StaffList = () =>
  import("@/views/staff_admin/modules/staff_list/staff_list");
const Operation = () =>
  import("@/views/staff_admin/modules/operation/operation");
const dismissionStaff = () =>
  import("@/views/staff_admin/modules/dismissionStaff/dismissionStaff");
const staffDetail = () =>
  import("@/views/staff_admin/modules/staff_detail/staff_detail");
const manageShop = () =>
  import("@/views/staff_admin/modules/staff_detail/modules/manage_shop");
const childProject = () => import("@/views/child_project/child_project");
const StoreCertification = () =>
  import("@/views/store_certification/store_certification");
const PaymentManage = () => import("@/views/payment_manage/payment_manage");
const WarehouseManage = () =>
  import("@/views/warehouse_manage/warehouse_manage");
const CustomerSuccessManagement = () =>
  import("@/views/customer_success_management/customer_success_management.vue");
const ShopUsageQuery = () => import("@/views/shop_usage_query/shop_usage_query");
const ShopAdmin = () => import("@/views/shop_admin/shop_admin");
const OldLs = () => import("@/views/shop_admin/modules/old_ls/old_ls");
const NewLs = () => import("@/views/shop_admin/modules/new_ls/new_ls");
const Operate = () =>
  import("@/views/shop_admin/modules/new_ls/operate/operate");
const Ph = () => import("@/views/shop_admin/modules/ph/ph");
const Pf = () => import("@/views/shop_admin/modules/pf/pf");
const Min = () => import("@/views/shop_admin/modules/min/min");
const Fuyou = () => import("@/views/shop_admin/modules/fuyou/fuyou");
const Pps = () => import("@/views/shop_admin/modules/pps/pps");
const StandaloneWxappApply = () =>
  import("@/views/shop_admin/modules/standalone-wxapp-apply/pps");
const RecordingShop = () =>
  import("@/views/shop_admin/modules/recording-shop/index");
const ShopUsageStatistics = () =>
  import("@/views/shop_admin/modules/standalone-wxapp-apply/shop-usage-statistics");
const StandaloneWxappApplyStatus = () =>
  import("@/views/shop_admin/modules/standalone-wxapp-apply/detail");
const TemplateLib = () =>
  import("@/views/shop_admin/modules/standalone-wxapp-apply/template-lib");
const TemplateDraft = () =>
  import("@/views/shop_admin/modules/standalone-wxapp-apply/template-draft");
const Ownauthenticates = () =>
  import("@/views/shop_admin/modules/ownauthenticates/ownauthenticates");
const ChannelApply = () =>
  import("@/views/shop_admin/modules/channel_apply/channel_apply");
const Wxminiprogrammanage = () =>
  import("@/views/shop_admin/modules/wxminiprogrammanage/wxminiprogrammanage");
const AllData = () => import("@/views/shop_admin/modules/all_data/all_data");
const shopApplyStatus = () =>
  import("@/views/shop_admin/modules/shopApply-status/shopApplyStatus");
const paymentStatus = () =>
  import("@/views/shop_admin/modules/payment-status/paymentStatus");
const wholesale = () => import("@/views/wholesale/wholesale");
const msgOperate = () =>
  import(
    "@/views/wholesale/components/message-manage/components/operate-record"
  );
const MarketShopList = () =>
  import("@/views/market-shop-list/market-shop-list");
const MarketShopImport = () =>
  import("@/views/market-shop-import/market-shop-import");
const financeManager = () => import("@/views/finance_manager/financeManager");
const financeRecorde = () => import("@/views/finance_manager/recorde/recorde");
const financeData = () =>
  import("@/views/finance_manager/finance_data/financeData");
const marketPaymentClaim = () =>
  import("@/views/finance_manager/market_payment_claim/index");
const invoiceManager = () =>
  import("@/views/finance_manager/invoice_manager/invoice_manager");
const refundManage = () => import("@/views/finance_manager/refund_manage/index");
const couponManager = () =>
  import("@/views/finance_manager/coupon_manager/coupon_manager");
const debtCollection = () =>
  import("@/views/debt_collection/debt_collection.vue");
// const demand = () => import('@/views/demand/demand')
// const demandUser = () => import('@/views/demand/demandUser')
const privacyFreeLogin = () => import("@/views/login/PrivacyFreeLogin");
const RegisteredUser = () => import("@/views/registered-user/registered-user");
const OnlinePayment = () => import("@/views/online_payment/onlinePayment.vue");

const NoPermission = () => import("@/views/no_permission/no_permission.vue");

const FINANCE_INVOICE_PERMISSION = 95;
const FINANCE_REFUND_PERMISSION = 96;
const FINANCE_COUPON_PERMISSION = 97;
const FINANCE_MARKET_PAYMENT_CLAIM_PERMISSION = 98;
const FINANCE_SUBSYSTEM_INCOME_PERMISSION = 99;
const COUPON_APPLY_REVIEW_PERMISSION = 100;
const FINANCE_ENTRY_PERMISSIONS = [
  FINANCE_INVOICE_PERMISSION,
  FINANCE_REFUND_PERMISSION,
  FINANCE_COUPON_PERMISSION,
  FINANCE_MARKET_PAYMENT_CLAIM_PERMISSION,
  FINANCE_SUBSYSTEM_INCOME_PERMISSION,
  COUPON_APPLY_REVIEW_PERMISSION,
];

// // 路由从外面导入进来
// import channelApply from '@/views/shop_admin/modules/channel-apply/route'

/**
 * 路由中meta中额headTitle用于显示在header中的标题
 * 三级及以后路由显示二级路由的展示名称，
 * 不写则不显示
 */

export default [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: NoPermission
    },
  {
    path: "/privacyFreeLogin",
    name: "privacyFreeLogin",
    component: privacyFreeLogin,
  },
  {
    path: "/common",
    name: "common",
    component: Common,
    children: [
      {
        path: "wxlogin",
        name: "commonWxLogin",
        component: CommonWxLogin,
        meta: {
          title: "企业微信登录",
        },
      },
      {
        path: "user-info",
        name: "commonUserInfo",
        component: CommonUserInfo,
        meta: {
          title: "用户信息",
        },
      },
    ],
  },
  {
    path: "/main",
    component: Main,
    redirect: "/main/functionList",
    children: [
      {
        path: "functionList",
        name: "functionList",
        component: FunctionList,
        meta: {
          permission: [
            1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14, 16, 17, 18, 19, 31, 41,
            22, 52, 53, 61, 71, 91, 92, 93, 94, 102, ...FINANCE_ENTRY_PERMISSIONS,
            111, 112, 113,
          ],
        },
      },
      {
        path: "staffAdmin",
        name: "staffAdmin",
        component: StaffAdmin,
        meta: {
          headTitle: "成员管理",
          permission: [1, 2, 3, 4, 5],
        },
        children: [
          {
            path: "staffList",
            name: "staffList",
            component: StaffList,
            meta: {
              name: "staffList",
              headTitle: "成员管理",
              permission: [1],
            },
          },
          {
            path: "operation",
            name: "operation",
            component: Operation,
            meta: {
              name: "operation",
              headTitle: "成员管理",
              permission: [5],
            },
          },
        ],
      },
      {
        path: "dismissionStaff",
        name: "dismissionStaff",
        component: dismissionStaff,
        meta: {
          headTitle: "成员管理",
          permission: [4],
        },
      },
      {
        path: "staffDetail",
        name: "staffDetail",
        component: staffDetail,
        meta: {
          headTitle: "成员管理",
          permission: [2],
        },
        children: [
          {
            path: "manageShop",
            name: "manageShop",
            component: manageShop,
            meta: {
              headTitle: "成员管理",
              permission: [2],
            },
          },
        ],
      },
      {
        path: "childProject",
        name: "childProject",
        component: childProject,
        meta: {
          headTitle: "系统入口",
          permission: [6, 7, 8, 92, 102],
        },
      },
      {
        path: "storeCertification",
        name: "storeCertification",
        component: StoreCertification,
        meta: {
          headTitle: "店铺认证",
          permission: [12],
        },
      },
      {
        path: "paymentManage",
        name: "paymentManage",
        component: PaymentManage,
        meta: {
          headTitle: "支付管理",
          permission: [13, 61],
        },
      },
      {
        path: "warehouseManage",
        name: "warehouseManage",
        component: WarehouseManage,
        meta: {
          headTitle: "仓库管理",
          permission: [21, 93],
        },
      },
      {
        path: "customerSuccessManagement",
        name: "customerSuccessManagement",
        component: CustomerSuccessManagement,
        meta: {
          headTitle: "客户成功管理",
          permission: [112],
          disableAdminBypass: true,
        },
      },
      {
        path: "shopUsageQuery",
        name: "shopUsageQuery",
        component: ShopUsageQuery,
        meta: {
          headTitle: "店铺使用时段查询",
          permission: [22],
        },
      },
      {
        path: "shopAdmin",
        name: "shopAdmin",
        component: ShopAdmin,
        redirect: "/main/shopAdmin/newls",
        meta: {
          headTitle: "新零售后台",
          permission: [11, 14, 16, 17, 18, 19, 113],
        },
        children: [
          {
            path: "newls",
            name: "newls",
            component: NewLs,
            meta: {
              headTitle: "新零售后台",
              permission: [11, 16, 17, 18, 19],
            },
          },
          {
            path: "operate",
            name: "operate",
            component: Operate,
            meta: {
              headTitle: "操作记录",
              permission: [11, 16, 17, 18, 19],
            },
          },
          {
            path: "oldls",
            name: "oldls",
            component: OldLs,
            meta: {
              headTitle: "新零售后台",
              permission: [11],
            },
          },
          {
            path: "ph",
            name: "ph",
            component: Ph,
            meta: {
              headTitle: "新零售后台",
              permission: [11],
            },
          },
          {
            path: "pf",
            name: "pf",
            component: Pf,
            meta: {
              headTitle: "新零售后台",
              permission: [11],
            },
          },
          {
            path: "wsc",
            name: "wsc",
            component: Min,
            meta: {
              headTitle: "新零售后台",
              permission: [11],
            },
          },
          {
            path: "alldata",
            name: "alldata",
            component: AllData,
            meta: {
              headTitle: "新零售后台",
              permission: [11],
            },
          },
          // channelApply,
          {
            path: "channelApply",
            name: "channelApply",
            component: ChannelApply,
            meta: {
              headTitle: "支付管理",
              permission: [13],
            },
          },
          // {
          //   path: 'channelApply',
          //   name: 'channelApply',
          //   component: ChannelApply,
          //   meta: {
          //     headTitle: '店铺管理',
          //     permission: [13]
          //   }
          // },
          {
            path: "fuyou",
            name: "fuyou",
            component: Fuyou,
            meta: {
              headTitle: "支付管理",
              permission: [13],
            },
          },
          {
            path: "ownauthenticates",
            name: "ownauthenticates",
            component: Ownauthenticates,
            meta: {
              headTitle: "店铺认证",
              permission: [12],
            },
          },
          {
            path: "standalone-wxapp-apply",
            name: "standalone-wxapp-apply",
            component: StandaloneWxappApply,
            meta: {
              headTitle: "新零售后台",
              permission: [14] /* TODO:权限 */,
            },
          },
          {
            path: "recording-shop",
            name: "recording-shop",
            component: RecordingShop,
            meta: {
              headTitle: "新零售后台",
              permission: [113],
            },
          },
          {
            path: "shop-usage-statistics",
            name: "shop-usage-statistics",
            component: ShopUsageStatistics,
            meta: {
              headTitle: "店铺使用时段查询",
              permission: [22],
            },
          },
          {
            path: "dealers",
            name: "dealers",
            component: Pps,
            meta: {
              headTitle: "新零售后台",
              permission: [12], // ？？还需要确认
            },
          },
          {
            path: "wxminiprogrammanage",
            name: "wxminiprogrammanage",
            component: Wxminiprogrammanage,
            meta: {
              headTitle: "新零售后台",
              // permission: []
            },
          },
        ],
      },
      {
        path: "shopApplyStatus",
        name: "shopApplyStatus",
        component: shopApplyStatus,
        meta: {
          headTitle: "店铺认证",
          permission: [12],
        },
      },
      {
        path: "StandaloneWxappApplyStatus",
        name: "StandaloneWxappApplyStatus",
        component: StandaloneWxappApplyStatus,
        meta: {
          headTitle: "新零售后台",
          permission: [14],
        },
      },
      {
        path: "TemplateLib",
        name: "TemplateLib",
        component: TemplateLib,
        meta: {
          headTitle: "新零售后台",
          permission: [14],
        },
      },
      {
        path: "TemplateDraft",
        name: "TemplateDraft",
        component: TemplateDraft,
        meta: {
          headTitle: "新零售后台",
          permission: [14],
        },
      },
      {
        path: "paymentStatus",
        name: "paymentStatus",
        component: paymentStatus,
        meta: {
          headTitle: "支付管理",
          permission: [13],
        },
      },
      {
        path: "wholesale",
        name: "wholesale",
        component: wholesale,
        meta: {
          headTitle: "市场/产区资料库",
          permission: [31],
        },
      },
      {
        path: "msgOperate",
        name: "msgOperate",
        component: msgOperate,
        meta: {
          headTitle: "市场/产区资料库",
          permission: [31],
        },
      },
      {
        path: "market-shop-list/:id",
        name: "marketShopList",
        component: MarketShopList,
        meta: {
          headTitle: "市场/产区资料库",
          permission: [31],
        },
      },
      {
        path: "market-shop-import",
        name: "marketShopImport",
        component: MarketShopImport,
        meta: {
          headTitle: "市场/产区资料库",
          permission: [31],
        },
      },
      {
        path: "financeManager",
        name: "financeManager",
        component: financeManager,
        meta: {
          headTitle: "财务管理",
          permission: FINANCE_ENTRY_PERMISSIONS,
        },
      },
      {
        path: "financeRecorde",
        name: "financeRecorde",
        component: financeRecorde,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_SUBSYSTEM_INCOME_PERMISSION],
        },
      },
      {
        path: "financeData",
        name: "financeData",
        component: financeData,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_SUBSYSTEM_INCOME_PERMISSION],
        },
      },
      {
        path: "invoiceManager",
        name: "invoiceManager",
        component: invoiceManager,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_INVOICE_PERMISSION],
        },
      },
      {
        path: "marketPaymentClaim",
        name: "marketPaymentClaim",
        component: marketPaymentClaim,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_MARKET_PAYMENT_CLAIM_PERMISSION],
        },
      },
      {
        path: "refundManage",
        name: "refundManage",
        component: refundManage,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_REFUND_PERMISSION],
        },
      },
      {
        path: "debtCollection",
        name: "debtCollection",
        component: debtCollection,
        meta: {
          headTitle: "欠款清收",
          permission: [94],
        },
      },
      {
        path: "couponManager",
        name: "couponManager",
        component: couponManager,
        meta: {
          headTitle: "财务管理",
          permission: [FINANCE_COUPON_PERMISSION, COUPON_APPLY_REVIEW_PERMISSION],
        },
      },
      {
        path: "couponApplyReview",
        name: "couponApplyReview",
        redirect: { name: "couponManager", query: { activeName: "applyReview" } },
        meta: {
          headTitle: "财务管理",
          permission: [COUPON_APPLY_REVIEW_PERMISSION],
        },
      },
      {
        path: "registeredUser",
        name: "registeredUser",
        component: RegisteredUser,
        meta: {
          headTitle: "线索池",
          permission: [52, 53],
        },

        children: [
          {
            path: "registeredUser",
            name: "importList",
            component: StaffList,
            meta: {
              name: "importList",
              headTitle: "导入列表",
              permission: [52],
            },
          },
          {
            path: "registeredUser",
            name: "registerList",
            component: Operation,
            meta: {
              name: "registerList",
              headTitle: "注册列表",
              permission: [53],
            },
          },
        ],
      },
      {
        path: "onlinePayment",
        name: "onlinePayment",
        component: OnlinePayment,
        meta: {
          headTitle: "支付管理",
          permission: [61],
        },
      },
      // {
      //   path: 'demand',
      //   name: 'demand',
      //   component: demand,
      //   meta: {
      //     headTitle: '用户反馈',
      //     permission: [41]
      //   }
      // },
      // {
      //   path: 'demandUser',
      //   name: 'demandUser',
      //   component: demandUser,
      //   meta: {
      //     headTitle: '用户反馈',
      //     permission: [41]
      //   }
      // },
    ],
  },
  {
    path: "/person",
    component: Person,
    name: "person",
  },
];
